import { Center, Stack, Text, Title } from 'ui';
import { useElementSize } from 'ui/Hooks';

const NoCartData = () => {
  const { ref, width } = useElementSize();

  const maxWidth = width <= 410;
  return (
    <Center ref={ref}>
      <Stack pb="lg">
        <Title order={2} ta="center" fz={{ base: 'lg', md: maxWidth ? 'lg' : 'xxl' }}>
          Your cart is empty
        </Title>
        <Text ta="center" fz={{ base: 'sm', md: maxWidth ? 'sm' : 'md' }}>
          Add donations, products, tickets and more while you support, so they’ll be ready for
          checkout later.
        </Text>
      </Stack>
    </Center>
  );
};

export { NoCartData };
